export const createGenericAccounts = {
  //KeyDetails
  createGenericAccountKeyDetailsTitle:
    "GenericAccount.CreateGenericAccount.KeyDetails",
  genericRegistrationCode: "KeyDetails.GenericRegistrationCode",
  numberOfAccounts: "KeyDetails.NumberOfAccounts",
  assigned: "KeyDetails.Assigned",
  registered: "KeyDetails.Registered",
  editViewGenericAccountStatusLabel: "KeyDetails.GenericAccountStatus",
  editViewGenericAccountStatusList: "KeyDetails.GenericAccountStatusList",

  //BasicDetails
  createGenericAccountBasicDetailsTitle:
    "GenericAccount.CreateGenericAccount.BasicDetails",
  genericAccountName: "BasicDetails.GenericAccountName",
  purpose: "BasicDetails.Purpose",
  client: "BasicDetails.Client",
  basicDetailsGenericRegistrationCode: "BasicDetails.GenericRegistrationCode",
  startDate: "BasicDetails.StartDate",
  expirationDate: "BasicDetails.ExpirationDate",
  basicDetailsNumberOfAccounts: "BasicDetails.NumberOfAccounts",
  programDurationDays: "BasicDetails.ProgramDurationDays",
  requestedBy: "BasicDetails.RequestedBy",
  purposeList: "BasicDetails.PurposeList",
  createGenericAccountStatusList: "BasicDetails.GenericAccountStatusList",
  createGenericAccountStatusLabel: "BasicDetails.GenericAccountStatus",
  createGenericAccountConfigurationTitle:
    "GenericAccount.CreateGenericAccount.Configuration",
  nextView: "Configuration.NextView",
  configurationCountry: "Configuration.Country",
  deliveryOffice: "Configuration.DeliveryOffice",
  nextProgramClass: "Configuration.NextProgramClass",
  tools: "Configuration.Tools",
  assessmentsAndTasks: "Configuration.AssessmentsAndTasks",
  thisAccountNameAlreadyExists: "BasicDetails.ThisAccountNameAlreadyExists",
  thisRegistrationCodeAlreadyExists:
    "BasicDetails.ThisRegistrationCodeAlreadyExists",
  expirationDateMustBeGreaterThanStartDate:
    "BasicDetails.ExpirationDateMustBeGreaterThanStartDate",
  startDateMustBeLesserThanExpirationDate:
    "BasicDetails.StartDateMustBeLesserThanExpirationDate",

  //Features
  createGenericAccountFeaturesTitle:
    "GenericAccount.CreateGenericAccount.Features",
  toolsSubHeading: "Features.ToolsSubHeading",
  assessmentsAndTasksSubHeading: "Features.AssessmentsAndTasksSubHeading",
  eventsAndWebinarsSubHeading: "Features.EventsAndWebinarsSubHeading",
  coachMeetingSubHeading: "Features.CoachMeetingSubHeading",
  assessmentsAndTasksList: "Features.AssessmentsAndTasksList",
  coachMeetingList: "Features.CoachMeetingList",
  eventsAndWebinarsList: "Features.EventsAndWebinarsList",
  toolsList: "Features.ToolsList",

  //GenericAccountHeader
  viewGenericAccountHeading: "GenericAccountHeader.ViewGenericAccountHeading",
  createGenericAccountGenericAccountHeaderTitle:
    "GenericAccount.CreateGenericAccount.GenericAccountHeader",
  genericAccountCreatedMessage:
    "GenericAccountHeader.GenericAccountCreatedMessage",
  editGenericAccountHeading: "GenericAccountHeader.EditGenericAccountHeading",
  genericAccountDetailsTab: "GenericAccountHeader.GenericAccountDetailsTab",
  genericAccountDetailsUpdatedMessage:
    "GenericAccountHeader.GenericAccountDetailsUpdatedMessage",
  registeredParticipantsTab: "GenericAccountHeader.RegisteredParticipantsTab",
  areYouSureYouWantToCreateGenericAccount:
    "GenericAccountHeader.AreYouSureYouWantToCreateGenericAccount",
  areYouSureYouWantToUpdateGenericAccountDetails:
    "GenericAccountHeader.AreYouSureYouWantToUpdateGenericAccountDetails",
  areYouSureYouWantToUpdateTheParticipantsDetails:
    "RegisteredParticipantsHeader.AreYouSureYouWantToUpdateTheParticipantsDetails",
  genericAccountUpdatedMessage:
    "GenericAccountHeader.GenericAccountUpdatedMessage",
  areYouSureYouWantToCancelTheGenericAccount:
    "GenericAccountHeader.AreYouSureYouWantToCancelTheGenericAccount",
  pleaseUpdateTheGenericAccountDetailsToProceed:
    "GenericAccountHeader.PleaseUpdateTheGenericAccountDetailsToProceed",

  // RegisteredParticipantsTab
  createGenericAccountRegisteredParticipantsTableTitle:
    "GenericAccount.CreateGenericAccount.RegisteredParticipantsTable",
  participantName: "RegisteredParticipantsTable.ParticipantName",
  emailId: "RegisteredParticipantsTable.EmailID",
  participantStatus: "RegisteredParticipantsTable.ParticipantStatus",
  programEndDate: "RegisteredParticipantsTable.ProgramEndDate",
  deliveryOffices: "RegisteredParticipantsTable.DeliveryOffices",
  registeredParticipantsTableCountry: "RegisteredParticipantsTable.Country",
  action: "RegisteredParticipantsTable.Action",
  noParticipantsRegistered:
    "RegisteredParticipantsTable.NoParticipantsRegistered",
  participantStatusList: "RegisteredParticipantsTable.ParticipantStatusList",
  searchParticipantName: "RegisteredParticipantsTable.SearchParticipantName",
  deliveryOfficeList: "RegisteredParticipantsTable.DeliveryOfficeList",

  //View Participant
  registeredParticipantsTitle:
    "GenericAccount.RegisteredParticipants.RegisteredParticipantsHeader",
  editParticipant: "RegisteredParticipantsHeader.EditParticipant",
  viewParticipant: "RegisteredParticipantsHeader.ViewParticipant",
  registeredParticipantDetailsUpdated:
    "RegisteredParticipantsHeader.RegisteredParticipantDetailsUpdated",

  participantInformationTitle:
    "GenericAccount.RegisteredParticipants.ParticipantInformation",
  participantInformationFirstName: "ParticipantInformation.FirstName",
  participantInformationLastName: "ParticipantInformation.LastName",
  participantInformationPreferredName: "ParticipantInformation.PreferredName",
  participantInformationEmail: "ParticipantInformation.Email",
  participantInformationAlternateEmail: "ParticipantInformation.AlternateEmail",
  participantInformationPreferredNumber:
    "ParticipantInformation.PreferredNumber",

  programInformationTitle:
    "GenericAccount.RegisteredParticipants.ProgramInformation",
  programInformationPlatformPersona: "ProgramInformation.PlatformPersona",
  programInformationJobLanded: "ProgramInformation.JobLanded",
  programInformationCareerProgram: "ProgramInformation.CareerProgram",
  programInformationProgramEndDate: "ProgramInformation.ProgramEndDate",

  platformDetailsTitle: "GenericAccount.RegisteredParticipants.PlatformDetails",
  platformDetailsTimeZone: "PlatformDetails.TimeZone",
  platformDetailsCityOfResidence: "PlatformDetails.CityOfResidence",
  platformDetailsLanguagePreference: "PlatformDetails.LanguagePreference",
  contactPreferencesTitle:
    "GenericAccount.RegisteredParticipants.ContactPreferences",
  contactPreferencesTextSMSNotificationsCheckbox:
    "ContactPreferences.TextSMSNotificationsCheckbox",
  contactPreferencesEmailNotificationsCheckbox:
    "ContactPreferences.EmailNotificationsCheckbox",
  preferredEmailNotifications:
    "ContactPreferences.PreferredEmailIDEmailNotifications",
  preferredTextSMSNotifications:
    "ContactPreferences.PreferredNumberTextSMSNotifications",
  sendEmailNotificationsToDropdown:
    "ContactPreferences.SendEmailNotificationsToDropdown",
  sendTextSMSNotificationsTo: "ContactPreferences.SendTextSMSNotificationsTo",
  email: "ContactPreferences.SelectedPreference.Email",
  textSMS: "ContactPreferences.SelectedPreference.TextSMS",
  selectedPreference: "ContactPreferences.SelectedPreference",

  activitySnapshotTitle:
    "GenericAccount.RegisteredParticipants.ActivitySnapshot",
  activitySnapshotLastLogin: "ActivitySnapshot.LastLogin",
  activitySnapshotJobsApplied: "ActivitySnapshot.JobsApplied",
  activitySnapshotEventsRegistered: "ActivitySnapshot.EventsRegistered",
  activitySnapshotCompletedAssessments: "ActivitySnapshot.CompletedAssessments",
  upcomingMeetingsTitle:
    "GenericAccount.RegisteredParticipants.UpcomingMeetings",
  //events
  eventTitle: "ManageParticipants.SessionsAndEvents.EventsTitle",
  eventKey: "CoachPortal.ManageParticipants.SessionsAndEvents",

  participantActivityTimelineTitle:
    "GenericAccount.RegisteredParticipants.ParticipantActivityTimeline",
  participantActivityTimelineFilterByCategory:
    "GenericAccount.RegisteredParticipants.ParticipantActivityTimeline.FilterByCategory",
  participantActivityTimelineShowFilterList:
    "GenericAccount.RegisteredParticipants.ParticipantActivityTimeline.ShowFilterList",
};
